<script>
    import {CONTACT} from "../js/constants.js";
    import app from "../stores/app";
    import department$ from "../stores/department$";
    import {rawPhone} from "../js/utils.js";
    import Icon from "./icons/Icon.svelte";

    let showUserDropdown = false;
    let showViewByDropdown = false;

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeUserDropdown();
            closeViewByDropdown();
        }
    }

    const toggleMenu = () => {
        $app.menuExpanded = $app.menuExpanded > 0 ? 0 : 2;
    }

    const toggleUserDropdown = () => {
        if (!showUserDropdown) {
            showUserDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        } else {
            closeUserDropdown();
        }
    }

    const closeUserDropdown = () => {
        showUserDropdown = false;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const toggleViewByDropdown = () => {
        if (!showViewByDropdown) {
            showViewByDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        } else {
            closeUserDropdown();
        }
    }

    const closeViewByDropdown = () => {
        showViewByDropdown = false;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const onItemClick = () => {
        $app.menuExpanded = 0;
    }
</script>

<header>
    <div class="top-bar">
        <div class="container d-flex align-items-center justify-content-between">
            <div class="left-side">
                <a href="/{$department$.link_code}" class="logo"><img src="/app/assets/images/logo.png" alt="logo"></a>
            </div>
            <div class="right-side">
                <div class="side-items">
                    <div class="side-item d-flex align-items-center">
                        <div class="menu-bars" id="menuToggler"><i class="fa fa-bars"></i></div>
                    </div>
                    <div class="side-item d-flex align-items-center gap-1 hidden-xs">
                        <div class="side-icon">
                            <Icon name="whatsapp" size="18"/>
                        </div>
                        <a href="https://wa.me/{rawPhone(CONTACT.WHATSAPP)}" target="_blank" rel="noopener noreferrer">
                            {CONTACT.WHATSAPP}
                        </a>
                    </div>
                    <div class="side-item d-flex align-items-center gap-1 hidden-xs">
                        <div class="side-icon">
                            <Icon name="phone" size="18"/>
                        </div>
                        <a href="tel:{rawPhone(CONTACT.PHONE)}">{CONTACT.PHONE}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="main-menu" id="mainMenu">
        <div class="container">
            <ul class="menu">
                <li><a href="/{$department$.link_code}">Book a Transfer</a></li>
                <li><a href="/{$department$.link_code}/terms" target="_blank">Terms</a></li>
            </ul>
        </div>
    </div>
</header>

<style>
    .top-bar {
        background: #fff;
        padding: 20px 0;
    }

    .top-bar .left-side {
        width: 180px;
    }

    .top-bar .left-side img {
        width: 100%;
    }

    .top-bar .right-side {

    }

    .top-bar .side-items {
        display: flex;
        align-items: center;
    }

    .top-bar .side-items .side-item {
        border-right: 1px solid #e1e1e1;
        padding: 0 20px;
    }

    .top-bar .side-items .side-item:last-of-type {
        border-right: none;
        padding-right: 0;
    }

    .top-bar .side-items .side-item a {
        color: #151515;
    }

    .top-bar .side-items .side-item a:hover {
        color: #50ba87;
    }

    .top-bar .side-items .side-item .side-icon {
        width: 18px;
        color: #01b3a7;
    }

    .top-bar .side-items .side-item .menu-bars {
        display: none;
        font-size: 22px;
        padding: 0 10px;
    }

    .top-bar .logo {
        height: 55px;
        display: block;
    }

    .top-bar .logo img {
        width: auto;
        height: 100%;
    }


    @media (max-width: 576px) {
        .top-bar {
            position: sticky;
            top: 0;
            border-bottom: 3px solid #162e44;
            padding: 10px 0;
            z-index: 8000;
        }

        /*.top-bar .left-side img {
            height: 100px;
        }*/
        .top-bar .side-items .side-item {
            border: none;
            padding: 0;
        }

        .top-bar .side-items .side-item .menu-bars {
            display: block;
        }

        .top-bar .logo {
            height: 30px;
        }
    }


    .main-menu {
        color: #fff;
        background: #162e44;
    }

    .main-menu ul.menu {
        list-style: none;
        width: max-content;
        padding: 0;
        margin: 0;
    }

    .main-menu ul.menu > li {
        display: inline-block;
    }

    .main-menu ul.menu > li > a {
        position: relative;
        display: block;
        font-size: 18px;
        color: #fff;
        padding: 15px 20px;
        /*    overflow: hidden;*/
    }

    .main-menu ul.menu > li > a:hover {
        background: #47596b;
    }

    .main-menu ul.menu > li > a:after {
        content: " ";
        display: block;
        clear: both;
        position: absolute;
        top: 0;
        left: 0;
        width: 0%;
        /*	transform: translateX(-100%);*/
        height: 5px;
        background: #01b3a7;
        transition: width .2s ease-in-out;
    }

    .main-menu ul.menu > li > a:hover:after {
        width: 100%;
    }

    .main-menu ul.menu > li.menu-dropdown {
        position: relative;
    }

    .main-menu ul.menu > li.menu-dropdown > a {

    }

    .main-menu ul.menu > li.menu-dropdown ul.menu-dropdown-options {
        display: none;
        list-style: none;
        position: absolute;
        background: #fff;
        width: max-content;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        padding: 20px 30px;
        z-index: 2000;
    }

    .main-menu ul.menu > li.menu-dropdown:hover ul.menu-dropdown-options {
        display: block;
    }

    .main-menu ul.menu > li.menu-dropdown ul.menu-dropdown-options > li > a {
        display: block;
        color: #535353;
        border-left: 0px solid #50ba87;
        padding: 3px 10px 3px 0;
        margin: 10px 0;
    }

    .main-menu ul.menu > li.menu-dropdown ul.menu-dropdown-options > li > a:hover {
        color: #50ba87;
        border-left-width: 5px;
        padding-left: 10px;
        padding-right: 0px;
    }

    @media (max-width: 576px) {
        .main-menu {
            position: fixed;
            top: 53px;
            left: 0;
            width: 100%;
            z-index: 2000;
            height: calc(100vh - 53px);
            transform: translateX(-100%);
            transition: all .3s ease-in-out;
        }

        .main-menu.open {
            transform: translateX(0);
        }

        .main-menu ul.menu {
            padding-top: 20px;
        }

        .main-menu ul.menu > li {
            display: block;
        }
    }

    @media (min-width: 577px) {
        .main-menu {
            position: sticky;
            top: 0;
            z-index: 8000;
        }
    }
</style>